"use strict";

import $ from "jquery";
// window.$ = window.jQuery = $;

export class Header {
  constructor() {
    console.log("Header module");
    // let $pageWrapper = $("body");
    let $body = $("body");
    let $lastScrollTop = 0;
    let $subItemControl = $("[data-submenu]");
    let $burgerMenu = $(".js__btn-burgerMenu");
    let $backLink = $(".js__btn-backLink");
    let $searchFormBtn = $('.js__btn__searchForm__mobile');
    let $searchFormClose = $('.js__searchForm__close');
    let $searchForm = $('.searchForm');

    $burgerMenu.on("click", function() {
      if ($body.hasClass("show__mainNavigation")) {
        $body.removeClass("show__mainNavigation");
      } else {
        $body.addClass("show__mainNavigation");
        document.getElementById('navigation').focus();
      }
    });

    // // subItemControl.each(function(){
    // $subItemControl.on("mouseover", function() {
    //   let level = $(this).data("submenu");
    //   let wrapperSubMenu = $(".submenuWrapper--" + level);
    //   let thisSubWrapperSubMenu = $(this)
    //     .closest("li")
    //     .find(".submenuWrapper:first");

    //   // if (!thisSubWrapperSubMenu.hasClass("submenuWrapper--show")) {
    //   //   wrapperSubMenu.removeClass("submenuWrapper--show");
    //   //   thisSubWrapperSubMenu.addClass("submenuWrapper--show");
    //   // } else {
    //   //   wrapperSubMenu.removeClass("submenuWrapper--show");
    //   // }
    //   wrapperSubMenu.removeClass("submenuWrapper--show");
    //   thisSubWrapperSubMenu.addClass("submenuWrapper--show");

    //   console.log('show menu: ',level);
    //   // })
    // });

    // $subItemControl.on("mouseleave", function() {
    //   let level = $(this).data("submenu");
    //   let wrapperSubMenu = $(".submenuWrapper--" + level);
    //   wrapperSubMenu.removeClass("submenuWrapper--show");
    // });

    // navigation mobile back level 
    $backLink.on("click", function() {
      let wrapperSubMenuToClose = $(this).closest(".submenuWrapper--show");
      wrapperSubMenuToClose.removeClass("submenuWrapper--show");
    });


    // comandi da tastiera per navigazione principale
    $(document).on("keyup", function(e) {
      if (e.key == "Escape") $body.removeClass("show__mainNavigation");
      if (e.ctrlKey && e.key === "m") $burgerMenu.trigger("click");
      // $body.removeClass("show__mainNavigation");
      // e.preventDefault();
    });

    // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
    window.addEventListener(
      "scroll",
      function() {
        // or window.addEventListener("scroll"....
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > $lastScrollTop) {
          $body.removeClass("scrollUp nearTop").addClass("scrollDown");
          // closeMenuAndResetAll();
        } else {
          $body.removeClass("scrollDown nearTop").addClass("scrollUp");
        }
        if (st === 0) {
          $body.removeClass("scrollDown scrollUp").addClass("nearTop");
        }
        if (st > 200) {
          $body.removeClass("show__mainNavigation");
        }

        $lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      },
      false
    );
  }
}
